import { render, staticRenderFns } from "./CheckboxFormItem.vue?vue&type=template&id=652ee50c"
import script from "./CheckboxFormItem.vue?vue&type=script&lang=js"
export * from "./CheckboxFormItem.vue?vue&type=script&lang=js"
import style0 from "./CheckboxFormItem.vue?vue&type=style&index=0&id=652ee50c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports